import axios from "./axios";

const action = {
    async CheckGibAccount(model) {
        return await axios().post("efaturabasvuru/basvuruSorgula", model
        ).then((res) => {
            return res;
        }).catch((err) => {
            return err;
        })
    }
}

export default action
